import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'intrasense-btn-loader',
  templateUrl: './btn-loader.component.html',
  styleUrls: ['./btn-loader.component.scss']
})
export class BtnLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
